<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody:{"cmd":"thirdMemberLogin","phone":"18200946810","name":"test","gender":"1","carCodeArray":["粤B81327"]},
            responseCode:{"data":{"authRedirectUrl":"https://devnew.xxx.xin/weixin/autologin/logining.do?onceToken=b43b64a70f5ea976aa842bec0734bf29","token":"b43b64a70f5ea976aa842bec0734bf29"},"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "此接口可实现第三方会员(手机号)无缝登录智慧停车微信端",
                t_url: this.commonUrls.test+"thirdMemberLogin",
                p_url: this.commonUrls.prod+"thirdMemberLogin",
                precondition: "该接口需要第三方保存有用户的手机号码等信息，用户如果在智慧停车注册过，则直接登录跳转，用户可以实现停车缴费和购买月票等功能；若为在智慧停车注册过，则先注册智慧停车，再登录智慧停车",
                pattern: "智慧停车开放平台提供接口，第三方接入系统主动请求，获取到登录地址后，可嵌入第三方的微信公众号中",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'appId', info2: '否', info3: 'String', info4: '微信公众号appId，用于使用指定微信公众号' },
                        { info1: 'phone', info2: '是', info3: 'String', info4: '用户手机号' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '用户姓名' },
                        { info1: 'nickName', info2: '否', info3: 'String', info4: '用户昵称' },
                        { info1: 'gender', info2: '否', info3: 'int', info4: '性别,1:男,2:女,0:未定义' },
                        { info1: 'carCodeArray', info2: '否', info3: 'String[]', info4: '车牌号列表,如["粤YAK123","粤YEL125"]1231黑3131' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'authRedirectUrl', info2: '是', info3: 'String', info4: '授权地址，目前只支持微信打开(只能打开一次，再次打开token失效)' },
                        { info1: 'token', info2: '是', info3: 'String', info4: '此次授权的token，目前暂无使用用途' },
                        ]
                }
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/other/h5/thirdMemberLogin.vue